/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '../charts/statistics' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>资源审核</el-breadcrumb-item>
    </el-breadcrumb>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="id" label="id" align="center" width="60">
      </el-table-column>
      <el-table-column prop="title" label="标题" align="center" width="150" >
      </el-table-column>
      <el-table-column prop="text" label="文案" align="center" width="200">
      </el-table-column>
      <el-table-column prop="phone" label="电话" align="center" width="100">
      </el-table-column>
      <el-table-column prop="img" label="图片" align="center" width="300">
        <template slot-scope="scope">
          <img style="width: 50%; height: auto;"  v-for="item in scope.row.img" :src="item" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="10">
        <template slot-scope="scope">
          <el-button size="mini" @click="submitForm(scope.$index, scope.row.id)">通过</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row.id)">拒绝</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { examineAd, approvalAd, noAd, PictureServer} from '../../api/userMG'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      listData: [], //用户数据
    }
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata()
  },
  methods: {
    getdata() {
      this.loading = true
      this.loading = false
      examineAd().then(res => {
          this.loading = false
          if (res.state == 200) {
            for(var i=0;i<res.data.adList.length;i++){
              var img_list=[PictureServer.Ad+res.data.adList[i][4]]
              res.data.adList[i][5].split(",").forEach(e=>{
                img_list.push(PictureServer.Ad+e)
              })
              this.listData.unshift({id:res.data.adList[i][0],title:res.data.adList[i][1],text:res.data.adList[i][2],phone:res.data.adList[i][3],img:img_list})
            }
          }
        })
    },
    // 编辑、增加页面保存方法
    submitForm(index, id) {
      approvalAd(id).then(res => {
        this.editFormVisible = false
        this.loading = false
        if (res.state == 200) {
          this.$message({
            type: 'success',
            message: '审核通过成功！'
          })
          this.listData.splice(index,1)
        }
      })
    },
    // 删除公司
    deleteUser(index, id) {
      this.$confirm('确定要拒绝吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        noAd(id).then(res => {
          this.$message({
            type: 'success',
            message: '已拒绝!'
          })
          this.listData.splice(index,1)
        })
      })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/machine/MachineConfig.vue